import barba from '@barba/core';
import gsap from 'gsap';
import Layer from 'ol/layer/Layer';
import Map from 'ol/Map';
import View from 'ol/View';
import {composeCssTransform} from 'ol/transform';
import $ from 'jquery';
import {DragPan, MouseWheelZoom, defaults} from 'ol/interaction';
import {platformModifierKeyOnly} from 'ol/events/condition';
import { remove } from 'ol/array';

window.history.scrollRestoration = "manual";

const body = document.querySelector('body');
const header = document.querySelector('main');
const transition = document.querySelector('.transition');
const bienalogo = document.getElementById('bienal-logo');
let indicator = document.getElementById("scrollIndicator");
const animapa = document.getElementById("svgContainer");
let h = body.clientHeight;
let btonPlayAnim = document.getElementById("botonPlayanim");
let contenedorMapa = document.getElementById("contenedorMapa");
let currentPage;
let cpdee = location.href.split("/").slice(-1);
currentPage = cpdee.toString();
let menuCreado;

function setHeight(bodyheight){
    transition.style.height = bodyheight + 'px';
    //console.log('setHeight');
}

window.addEventListener('load', () => {
  saberPaginaActual();
    //console.log('The page has fully loaded' + ' top = ' + window.scrollY);
    console.log(currentPage);
    

});

function saberPaginaActual(){
  if(currentPage == "" || currentPage == "index.html"){
    initAll();
    nuevoMenu();
    setEsconderMenu();
    setMenuProperties();
    cargarModals();
    relacionesColectivasMenu();
    animapa.style.display = "none";
  }else if(currentPage == "mapa.html"){
    setMap();
    nuevoMenu();
    setEsconderMenu();
    setMenuProperties();
    cargarModals();
    relacionesColectivasMenu();
  }
  else if(currentPage == "proximasactividades.html"){
    nuevoMenu();
    setEsconderMenu();
    setMenuProperties();
  }
  else{
    setMap();
    nuevoMenu();
    setEsconderMenu();
    setMenuProperties();
    cargarModalsTemplates();
    animacionDeSecciones();
  }
};

function initAll() {
    body.classList.add('in-home');
    header.classList.add('in-home-none');
    transition.style.height = '230vh';
    body.style.height = '100vh';

    const bienal = lottie.loadAnimation({
      container: bienalogo, // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: './images/home/logo-bienal.json' // the path to the animation json
    });

    bienal.play();

    bienal.onComplete = function() {
      body.style.height = '100vh';
    
      const bienalmapaGeneral = lottie.loadAnimation({
        container: bienalogo, // the dom element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: false,
        speed:10,
        path: './images/home/mapa-general.json' // the path to the animation json
      });
      
      btonPlayAnim.addEventListener("click", correanimacion);

  
      bienalmapaGeneral.addEventListener("enterFrame", function() {
        btonPlayAnim.style.display = "block";
        const myTimeou1 = setTimeout(scrollAnima, 200);
        const myTimeout2 = setTimeout(cambiarScrollTexto, 2000);
        const myTimeout3 = setTimeout(correanimacion, 2000);
      });

      function correanimacion() {
        bienalmapaGeneral.play();
        btonPlayAnim.style.display = "none";
      };

      bienalmapaGeneral.onComplete = function(){
            header.classList.remove('in-home-none');
            bienalmapaGeneral.destroy();
            btonPlayAnim.remove();
            indicator.style.display = "none";
            setMap();
            abrirModalPrincipal();
            scrollaMapa();
            
      }

      function cambiarScrollTexto(){
        indicator.innerHTML = "Saltar intro";
        indicator.addEventListener("click",skipIntro);
      
      }

      function skipIntro(){
        header.classList.remove('in-home-none');
        bienalmapaGeneral.destroy();
        indicator.style.display = "none";
        setMap();
        abrirModalPrincipal();
        scrollaMapa();
      }

      //bienalmapaGeneral.destroy();


    //   LottieScrollTrigger({
    //     target: "#svgContainer",
    //     path: "mapa-general.json",
    //     speed: "medium",
    //     renderer: 'svg',
    //     rendererSettings: {
    //       preserveAspectRatio: "xMidYMid slice",
    //       imagePreserveAspectRatio: "xMidYMid slice",
    //       viewBoxOnly: true,
    //       //viewBoxSize: "0 0 1920 1080",
    //       progressiveLoad: true,
    //       className: "mapa"
    //       },
    //     scrub: 1, 
    //  });
     
    indicator.style.opacity = '1';
    // body.style.height = '350vh';
    body.classList.remove('in-home');
    
    
    }
  
}

function initAllColectivos(){
    body.classList.remove('in-home');
    
}

function loaderIn() {
    body.classList.remove('in-home');
    return gsap.fromTo('.transition', 
    {
      y: '100%',
  },
  {
      duration: 2,
      y: '-20%',
      ease: 'power1.out',
  });
}

function loaderAway() {
  return gsap.to('.transition', {
      duration: 2,
      y: '50%',
      ease: 'power4.inOut',
  });
}

// barba.init({
//     debug: true,
//     transitions: [{
//         //once: ({next}) => onceAnimation(next.container),
//         async leave() {
//             await loaderIn();
//         },
//         enter() {
//             loaderAway();
//         }
//     }],
//     views: [
//       {
//         namespace: 'home',
//           beforeEnter(data) {
//             alert("beforeEnter Index");
//             initAll();
//             setMap();
//             nuevoMenu();
//             setEsconderMenu();
//             setMenuProperties();
//             cargarModals();
//           // do something before leaving the current `index` namespace
//         },
//         beforeLeave(data) {
//           alert("beforeLeave Index");
          
//         },
//         afterLeave(data) {
//           alert("afterLeave Index");
//           ///Ocultar Modal
//           $('body').removeClass('modal-open');
//           $('.modal-backdrop').remove();
          
//           // do something before leaving the current `index` namespace
//         },
        
//       },
//       {
//         namespace: 'colectivo',
//           beforeEnter(data) {
//             alert("beforeEnter Colectivo");
//             animacionDeSecciones();
//             //initAllColectivos();
//             setMap();
//             nuevoMenu();
//             setEsconderMenu();
//             setMenuProperties();
//             cargarModalsTemplates();
            
          
//         },
//         beforeLeave(data) {
//           alert("beforeLeave Colectivo");

//           closeNav();
          
//         },
//         afterLeave(data) {
//           alert("afterLeave Colectivo");
          
//         }
//       },
//     ],
//  });


function setMap(){
  let mapaRender; 
  let mTarget; 

    switch(currentPage){
      case "ave-fenix.html":
        mapaRender = "./images/colectivos/avefenix/aveFenix.svg";
        mTarget = "AveFenix";
      break;
      case "ave-fenix.html#secMapa":
        mapaRender = "./images/colectivos/avefenix/aveFenix.svg";
        mTarget = "AveFenix";
      break;
      case "ave-fenix.html#secDescripcion":
        mapaRender = "./images/colectivos/avefenix/aveFenix.svg";
        mTarget = "AveFenix";
      break;
      case "ave-fenix.html#secComunidad":
        mapaRender = "./images/colectivos/avefenix/aveFenix.svg";
        mTarget = "AveFenix";
      break;
      case "ave-fenix.html#secProyecto":
        mapaRender = "./images/colectivos/avefenix/aveFenix.svg";
        mTarget = "AveFenix";
      break;
    
      case "casa-pora.html":
        mapaRender = "./images/colectivos/casapora/casaPora.svg";
        mTarget = "CasaPora";
      break;
      case "casa-pora.html#secMapa":
        mapaRender = "./images/colectivos/casapora/casaPora.svg";
        mTarget = "CasaPora";
      break;
      case "casa-pora.html#secDescripcion":
        mapaRender = "./images/colectivos/casapora/casaPora.svg";
        mTarget = "CasaPora";
      break;
      case "casa-pora.html#secComunidad":
        mapaRender = "./images/colectivos/casapora/casaPora.svg";
        mTarget = "CasaPora";
      break;
      case "casa-pora.html#secProyecto":
        mapaRender = "./images/colectivos/casapora/casaPora.svg";
        mTarget = "CasaPora";
      break;

      case "conexo.html":
        mapaRender = "./images/colectivos/conexo/conexo.svg";
        mTarget = "Conexo";
      break;
      case "conexo.html#secMapa":
        mapaRender = "./images/colectivos/conexo/conexo.svg";
        mTarget = "Conexo";
      break;
      case "conexo.html#secDescripcion":
        mapaRender = "./images/colectivos/conexo/conexo.svg";
        mTarget = "Conexo";
      break;
      case "conexo.html#secComunidad":
        mapaRender = "./images/colectivos/conexo/conexo.svg";
        mTarget = "Conexo";
      break;
      case "conexo.html#secProyecto":
        mapaRender = "./images/colectivos/conexo/conexo.svg";
        mTarget = "Conexo";
      break;
      
      case "educacion-aborigen.html":
        mapaRender = "./images/colectivos/educacionaborigen/estudiosInterdisciplinarios.svg";
        mTarget = "EstudiosInterdisciplinarios";
      break;
      case "educacion-aborigen.html#secMapa":
        mapaRender = "./images/colectivos/educacionaborigen/estudiosInterdisciplinarios.svg";
        mTarget = "EstudiosInterdisciplinarios";
      break;
      case "educacion-aborigen.html#secDescripcion":
        mapaRender = "./images/colectivos/educacionaborigen/estudiosInterdisciplinarios.svg";
        mTarget = "EstudiosInterdisciplinarios";
      break;
      case "educacion-aborigen.html#secComunidad":
        mapaRender = "./images/colectivos/educacionaborigen/estudiosInterdisciplinarios.svg";
        mTarget = "EstudiosInterdisciplinarios";
      break;
      case "educacion-aborigen.html#secProyecto":
        mapaRender = "./images/colectivos/educacionaborigen/estudiosInterdisciplinarios.svg";
        mTarget = "EstudiosInterdisciplinarios";
      break;
      
      case "la-polinizadora.html":
        mapaRender = "./images/colectivos/polinizadora/polinizadora.svg";
        mTarget = "Polinizadora";
      break;
      case "la-polinizadora.html#secMapa":
        mapaRender = "./images/colectivos/polinizadora/polinizadora.svg";
        mTarget = "Polinizadora";
      break;
      case "la-polinizadora.html#secDescripcion":
        mapaRender = "./images/colectivos/polinizadora/polinizadora.svg";
        mTarget = "Polinizadora";
      break;
      case "la-polinizadora.html#secComunidad":
        mapaRender = "./images/colectivos/polinizadora/polinizadora.svg";
        mTarget = "Polinizadora";
      break;
      case "la-polinizadora.html#secProyecto":
        mapaRender = "./images/colectivos/polinizadora/polinizadora.svg";
        mTarget = "Polinizadora";
      break;
      
      case "ninas-anomalas.html":
        mapaRender = "./images/colectivos/ninasanomalas/ninasAnomalas.svg";
        mTarget = "NinasAnomalas";
      break;
      case "ninas-anomalas.html#secMapa":
        mapaRender = "./images/colectivos/ninasanomalas/ninasAnomalas.svg";
        mTarget = "AveFenix";
      break;
      case "ninas-anomalas.html#secDescripcion":
        mapaRender = "./images/colectivos/ninasanomalas/ninasAnomalas.svg";
        mTarget = "AveFenix";
      break;
      case "ninas-anomalas.html#secComunidad":
        mapaRender = "./images/colectivos/ninasanomalas/ninasAnomalas.svg";
        mTarget = "AveFenix";
      break;
      case "ninas-anomalas.html#secProyecto":
        mapaRender = "./images/colectivos/ninasanomalas/ninasAnomalas.svg";
        mTarget = "AveFenix";
      break;
      
      case "popayork-minga.html":
        mapaRender = "./images/colectivos/popayork/popayork.svg";
        mTarget = "Popayork";
      break;
      case "popayork-minga.html#secMapa":
        mapaRender = "./images/colectivos/popayork/popayork.svg";
        mTarget = "Popayork";
      break;
      case "popayork-minga.html#secDescripcion":
        mapaRender = "./images/colectivos/popayork/popayork.svg";
        mTarget = "Popayork";
      break;
      case "popayork-minga.html#secComunidad":
        mapaRender = "./images/colectivos/popayork/popayork.svg";
        mTarget = "Popayork";
      break;
      case "popayork-minga.html#secProyecto":
        mapaRender = "./images/colectivos/popayork/popayork.svg";
        mTarget = "Popayork";
      break;
      
      case "rhesident-org.html":
        mapaRender = "./images/colectivos/rhesident/rhesidentOrg.svg";
        mTarget = "RhesidentOrg";
      break;
      case "rhesident-org.html#secMapa":
        mapaRender = "./images/colectivos/rhesident/rhesidentOrg.svg";
        mTarget = "RhesidentOrg";
      break;
      case "rhesident-org.html#secDescripcion":
        mapaRender = "./images/colectivos/rhesident/rhesidentOrg.svg";
        mTarget = "RhesidentOrg";
      break;
      case "rhesident-org.html#secComunidad":
        mapaRender = "./images/colectivos/rhesident/rhesidentOrg.svg";
        mTarget = "RhesidentOrg";
      break;
      case "rhesident-org.html#secProyecto":
        mapaRender = "./images/colectivos/rhesident/rhesidentOrg.svg";
        mTarget = "RhesidentOrg";
      break;
      
      case "volcan.html":
        mapaRender = "./images/colectivos/volcan/volcan.svg";
        mTarget = "Volcan";
      break;
      case "volcan.html#secMapa":
        mapaRender = "./images/colectivos/volcan/volcan.svg";
        mTarget = "Volcan";
      break;
      case "volcan.html#secDescripcion":
        mapaRender = "./images/colectivos/volcan/volcan.svg";
        mTarget = "Volcan";
      break;
      case "volcan.html#secComunidad":
        mapaRender = "./images/colectivos/volcan/volcan.svg";
        mTarget = "Volcan";
      break;
      case "volcan.html#secProyecto":
        mapaRender = "./images/colectivos/volcan/volcan.svg";
        mTarget = "Volcan";
      break;

      case "mapa.html":
        mapaRender = "./images/colectivos/general/mapaGeneralColectivos.svg";
        mTarget = "General";
        break;
      
      case "index.html":
        mapaRender = "./images/colectivos/general/mapaGeneralColectivos.svg";
        mTarget = "General";
        break;
      default:
        mapaRender = "./images/colectivos/general/mapaGeneralColectivos.svg";
        mTarget = "General";
      
    };
    
    var mapaTarget = document.getElementById("map").id = "map"+mTarget;

      if( (currentPage == "index.html") || (currentPage == "") || (currentPage == "mapa.html") ){
        let map = new Map({
          target: mapaTarget,
          view: new View({
            center: [0, 0],
            extent: [-180, -90, 180, 90],
            projection: 'EPSG:3857',
            zoom: 1,
            enableRotation: false
          })

         });

         const svgContainer = document.createElement('div');
       const xhr = new XMLHttpRequest();
      xhr.open('GET', mapaRender);
       xhr.addEventListener('load', function () {
        const svg = xhr.responseXML.documentElement;
        svgContainer.ownerDocument.importNode(svg);
        svgContainer.appendChild(svg);
       });
       xhr.send();
        
       const width = 2560;
       const height = 1600;
       const svgResolution = 300 / width;
       svgContainer.style.width = width + 'px';
       svgContainer.style.height = height + 'px';
       svgContainer.style.transformOrigin = 'top left';
       svgContainer.className = 'svg-layer';
        
       map.addLayer(
        new Layer({
          render: function (frameState) {
            const scale = svgResolution / frameState.viewState.resolution;
            const center = frameState.viewState.center;
            const size = frameState.size;
            const cssTransform = composeCssTransform(
              size[0] / 2,
              size[1] / 2,
              scale,
              scale,
              frameState.viewState.rotation,
              -center[0] / svgResolution - width / 2,
              center[1] / svgResolution - height / 2
            );
            svgContainer.style.transform = cssTransform;
            svgContainer.style.opacity = this.getOpacity();
            return svgContainer;
          },
        })
       );

      }else {
        let map = new Map({
          target: mapaTarget,
          view: new View({
            center: [0, 0],
            extent: [-180, -90, 180, 90],
            projection: 'EPSG:3857',
            zoom: 1,
            enableRotation: false
          }),
          interactions: defaults({dragPan: false, mouseWheelZoom: false}).extend([
            new DragPan({
              condition: function (event) {
                return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
              },
            }),
            new MouseWheelZoom({
              condition: platformModifierKeyOnly,
            }),
          ])
         });

         const svgContainer = document.createElement('div');
       const xhr = new XMLHttpRequest();
      xhr.open('GET', mapaRender);
       xhr.addEventListener('load', function () {
        const svg = xhr.responseXML.documentElement;
        svgContainer.ownerDocument.importNode(svg);
        svgContainer.appendChild(svg);
       });
       xhr.send();
        
       const width = 2560;
       const height = 1600;
       const svgResolution = 300 / width;
       svgContainer.style.width = width + 'px';
       svgContainer.style.height = height + 'px';
       svgContainer.style.transformOrigin = 'top left';
       svgContainer.className = 'svg-layer';
        
       map.addLayer(
        new Layer({
          render: function (frameState) {
            const scale = svgResolution / frameState.viewState.resolution;
            const center = frameState.viewState.center;
            const size = frameState.size;
            const cssTransform = composeCssTransform(
              size[0] / 2,
              size[1] / 2,
              scale,
              scale,
              frameState.viewState.rotation,
              -center[0] / svgResolution - width / 2,
              center[1] / svgResolution - height / 2
            );
            svgContainer.style.transform = cssTransform;
            svgContainer.style.opacity = this.getOpacity();
            return svgContainer;
          },
        })
       );
      }
        
     


}

function getTop (frame){
  var t = document.body.getBoundingClientRect().top;

  //console.log(frame);
  //console.log("top= " + t);

  // if (frame > 250){
  //   console.log(frame);
  // }

  if (t == 0){
    indicator.classList.remove('setBottom');
    bienalogo.classList.remove('setTop');
  } else if ((t < 0) && (frame > 115)) {
    indicator.classList.add("setBottom");
    bienalogo.classList.add('setTop');
    indicator.style.display = "none";
  } else {
    indicator.classList.add("setBottom");
    bienalogo.classList.add('setTop');
    indicator.style.display = "block";
  }

}

function LottieScrollTrigger(vars) {
  let playhead = {frame: 0},
      target = gsap.utils.toArray(vars.target)[0],
      speeds = {slow: "+=2000", medium: "+=1000", fast: "+=500"},
      st = {trigger: target, pin: true, pinSpacing: false, start: "top top", end: speeds[vars.speed] || "+=1000", scrub: 1},
      animation = lottie.loadAnimation({
          container: target,
          renderer: vars.renderer || "svg",
          rendererSettings: vars.rendererSettings,
          loop: false,
          autoplay: true,
          path: vars.path
      });
      
  for (let p in vars) { // let users override the ScrollTrigger defaults
      st[p] = vars[p];
  }
  
  animation.addEventListener("DOMLoaded", function() {

      gsap.to(playhead, {
          frame: animation.totalFrames - 1,
          ease: "none",
          onUpdate: () => {
            animation.goToAndStop(playhead.frame, true);
            getTop(playhead.frame);
          },
          onComplete: () => {
            body.style.height = '100vh';
            animapa.parentNode.style.display = "none";
            lottie.destroy();
            setMap();
            nuevoMenu();
            setEsconderMenu();
            setMenuProperties();
            cargarModals();
            console.log('Ocultar y mostrar mapa');
          },
          onUpdateParams: [playhead.frame],
          scrollTrigger: st
      });

  // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
  ScrollTrigger.sort();
  ScrollTrigger.refresh();
  ScrollTrigger.clearScrollMemory();

  });
  return animation;
  }

  document.addEventListener("DOMContentLoaded", function() {
    //console.log('DOM loaded');
    gsap.registerPlugin(ScrollToPlugin);
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(MotionPathPlugin);
  });


  window.addEventListener('resize', function() {
  //console.log('resize');
  lottie.resize();
  });


/* ##################################*/
/* ####### CUSTOM JS ############ */
/* ##################################*/

// Funciones para menú general de la Bienal
function setEsconderMenu(){
  document.getElementById('btnAbrirMenu').addEventListener('click', openNav);
  document.getElementById('abrirMenuBars').addEventListener('click', openNav);
  document.getElementById('btnCerrarMenu').addEventListener('click', closeNav);
}
// Para abrir menú
function openNav() {
  document.getElementById("myNav").style.width = "100%";
}
// Para cerrar menú
function closeNav() {
  document.getElementById("myNav").style.width = "0%";
}
// Para bloquear link en la current page
function setMenuProperties(){
  var x = document.querySelectorAll(".overlay-content a");

  x.forEach(element =>{
    let menuIds = element.getAttribute("id");
    let menuhrefs = "/" + element.getAttribute("href");
    //let currentPage = window.location.pathname;
  
    var aId = document.getElementById(menuIds);
    if (currentPage == ""){
      currentPage = "index.html";
    }
    if(menuhrefs == currentPage){
      Object.assign(aId.classList = "menuHrefsActive");
    }else {
      Object.assign(aId.classList = "menuHrefsInactive");
    }
  });
};
// Para generar el menú en cada página navegada
function nuevoMenu(){
  var div = document.createElement('div');
  div.setAttribute("id", "menuCreado");

  let menuhtml = '<div class="container">' +
  '<nav class="autohide navbar navbar-expand-lg navbar-dark">' +
    '<div class="container">' +
      '<a class="navbar-brand logonavbar" href="https://www.unam.mx/" target="_blank">' +
        '<img class="logoUnamHeader" src="./images/footer/logo-unam.png" alt="Logo">' +
      '</a>' +
      '<a class="navbar-brand logonavbar" href="https://fad.unam.mx/" target="_blank">' +
        '<img src="./images/footer/logo-fad.png" alt="Logo">' +
      '</a>' +
      '<a class="navbar-brand logonavbar" href="index.html">' +
        '<img class="logoBienalHeader" src="./images/home/logo-min.png" alt="Logo">' +
      '</a>' +
      '<button id="abrirMenuBars" class="navbar-toggler" type="button" data-bs-toggle="collapse">' +
        '<span class="navbar-toggler-icon"></span>' +
      '</button>' +
    '<div class="collapse navbar-collapse" id="main_nav">' +
    '<ul class="navbar-nav ms-auto">' +
    '<li class="nav-item"><a href="mapa.html" class="nav-link" data-bs-toggle="collapse" > MAPA </a></li>' +
    '<li class="nav-item"><a id="btnAbrirMenu" class="nav-link" data-bs-toggle="collapse" > COLECTIVAS </a></li>' +
    '<li class="nav-item"><a href="proximasactividades.html" class="nav-link" data-bs-toggle="collapse" > PRÓXIMOS EVENTOS </a></li>' +
    '</ul>' +
    '</div> ' +
    '</div> ' +
  '</nav>' +

'</div>' +
'<div id="myNav" class="overlay">' +
  '<a id="btnCerrarMenu" href="javascript:void(0)" class="closebtn">&times;</a>' +
  '<div class="overlay-content">' +
    '<a id="menuLinkInicio" href="mapa.html">Mapa</a>' +
    '<a id="menuLinkCauca" href="ave-fenix.html">Ave Fenix</a>' +
    '<a id="menuLinkInicio" href="conexo.html">Conexo</a>' +
    '<a id="menuLinkCauca" href="educacion-aborigen.html">Estudios interdisciplinarios en educación aborígen</a>' +
    '<a id="menuLinkInicio" href="la-polinizadora.html">La Polinizadora</a>' +
    '<a id="menuLinkCauca" href="casa-pora.html">Casa Pora</a>' +
    '<a id="menuLinkInicio" href="ninas-anomalas.html">Niñas Anómalas</a>' +
    '<a id="menuLinkCauca" href="popayork-minga.html">Corporación Cultural Popayork y Minga. Prácticas decoloniales</a>' +
    '<a id="menuLinkInicio" href="rhesident-org.html">Rhesident Org</a>' +
    '<a id="menuLinkCauca" href="volcan.html">Volcán</a>' +
    '<a id="menuLinkCauca" href="proximasactividades.html">Próximas actividades</a>' +
  '</div>' +
'</div>';

  //div.innerHTML = document.getElementById('pruebaMenu').innerHTML;
  div.innerHTML = menuhtml;
  document.getElementById('espacioParaMenu').appendChild(div);
}

// Para destruir menu anterior
function removerMenu(){
  menuCreado = document.getElementById("menuCreado"); 
  menuCreado.remove();
}

// Funciones para animación de logo entrada
// Activar/Desactivar la animación de logo de entrada
//lottieTest();

// Para generar animación lottie de logo desde json
function lottieTest(){
  var animation = lottieWeb.loadAnimation({
    container: document.getElementById('svgTest'),
    path: './json/data.json',
    renderer: 'svg',
    loop: false,
    autoplay: true,
    name: "Demo Animation",
  });
  document.getElementById("bodyWrapper").style.overflowY = "hidden";
  var myVar;
  myVar = setTimeout(showPage, 10000);
}
// Para mostrar página después de que termina la animación lottie
function showPage() {
  document.getElementById("svgTest").className = "mueveteAnim";
  document.getElementById("bodyWrapper").style.overflowY = "initial";
  esconderLoader();
}
// Para esconder animación Lottie
function esconderLoader(){
  window.setTimeout(function(){ document.getElementById("svgTest").style.display="none"; }, 5000);
};

function botonModals(){
    var items = document.getElementsByClassName('botonModalTestClass');
  for (var i = 0; i < items.length; i++) {
    items[i].addEventListener('click', loadDoc);
  }
}

// Generador de código para Modals
const XmlReader = require('xml-reader');
const xmlQuery = require('xml-query');
const reader = XmlReader.create();

function cargarModals(){
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      let xmlCompleto = xhttp.responseText;
      pintarModals(this,1);  
    }
  };
  xhttp.withCredentials = true;
  xhttp.open("GET", "./modals/modals.xml", true);
  xhttp.setRequestHeader('Content-Type', 'text/xml');
  xhttp.send();
}
function cargarModalsTemplates(){
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      let xmlCompleto = xhttp.responseText;
      pintarModals(this,2);  
    }
  };
  xhttp.withCredentials = true;
  xhttp.open("GET", "./modals/modalstemplates.xml", true);
  xhttp.setRequestHeader('Content-Type', 'text/xml');
  xhttp.send();
}
function pintarModals(xml,tipo){
  var i;
  var xmlDoc = xml.responseXML;
  var table="";
  var x = xmlDoc.getElementsByTagName("COLECTIVO");
  var vacio = "";

  if(tipo == "1"){
    for (i = 0; i <x.length; i++) {

      table += '<div class="modal fade" id="' + x[i].getElementsByTagName("IDENTIFICADOR")[0].childNodes[0].nodeValue + '" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">' + 
      '<div class="modal-dialog modal-md modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header"><img class="img-fluid imgLogoModal" src="./images/colectivos/' +
      x[i].getElementsByTagName("LOGO")[0].childNodes[0].nodeValue  +
      '" alt="Logo Modal Popayork"></div><div class="modal-body"><div class="row"><div class="col-12"><p>' + 
      x[i].getElementsByTagName("DESCRIPCION")[0].childNodes[0].nodeValue  +
      '</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-secondary boton-regresar" data-dismiss="modal"> Regresar</button><a href="' + 
      x[i].getElementsByTagName("URL")[0].childNodes[0].nodeValue  +
      '" class="boton-verMas">Ver Colectiva</a></div></div></div></div>'
    };
  
  }else if(tipo ==2){
    for (i = 0; i <x.length; i++) {

      table += '<div class="modal fade" id="' + x[i].getElementsByTagName("IDENTIFICADOR")[0].childNodes[0].nodeValue + '" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">' + 
      '<div class="modal-dialog modal-md modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-body"><div class="row"><div class="col-12"><p>' + 
      x[i].getElementsByTagName("DESCRIPCION")[0].childNodes[0].nodeValue  +
      '</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-secondary boton-regresar" data-dismiss="modal"> Regresar</button></div></div></div></div>'
    };
  
  }
  document.getElementById("demo").innerHTML = table;

};

// ScrollTrigger para secciones de colectivos
function animacionDeSecciones(){
  
gsap.registerPlugin(ScrollTrigger);

// Animacion de Descripción
let seccion01 = gsap.timeline({
  scrollTrigger: {
  trigger: "#descripcion",
  start: "top bottom",
  end: "+=150%",
  scrub: true,
  }
});
seccion01.fromTo("#descripcion article", {opacity:0},{opacity:1,delay:.5})

ScrollTrigger.refresh();

// Animacion de comunidad
let comunidad = gsap.timeline({
  scrollTrigger: {
  trigger: "#comunidad",
  // start: "center 300px",
  start: "top top",
  end: "+=100",
  pin:"#comunidadPin",
  scrub: true,
  //markers:true,
  refreshPriority: 1
  }
});
comunidad.fromTo("#comunidad article",{opacity:0},{opacity:1,delay:.5})

// Animacion de Proyecto
let sec03 = gsap.timeline({
  scrollTrigger: {
    trigger: "#proyecto",
    start: "top bottom",
    end: "+=150%",
    scrub: true,
    }
  });
sec03.fromTo("#proyecto article", {opacity:0},{opacity:1,delay:1})

// Efecto de Scroll entre secciones
gsap.utils.toArray(".panel").forEach((panel, i) => {
  ScrollTrigger.create({
    trigger: panel,
    start: "top top-=32px", 
    pin: true, 
    id: "#" + panel.getAttribute("id"),
    //end: "+=150%",
    pinSpacing: false
  });
});


gsap.utils.toArray(".menuEntreSecciones ul li a").forEach(function(a) {
  
  a.addEventListener("click", function(e) {
    
    e.preventDefault();
    const id = a.getAttribute("href"),
    //console.log(id);
    trigger = ScrollTrigger.getById(id);
    gsap.to(window, {
     duration: .5,
     scrollTo: trigger ? trigger.start : id
    });
  });
});

}

//Nubes dentro de colectivo
let descrioncionDiv = document.getElementById("descripcion");
//let descripcionWidth = document.getElementById("secDescripcion").clientWidth;
let intViewportWidth = window.innerWidth;
// let intViewportHeight = window.innerHeight;

let sum = intViewportWidth * 0.21 + 'px';
let nubes;
switch(currentPage){
  case "ave-fenix.html":
    nubes = "nubes-avefenix.png";
  break;
  case "casa-pora.html":
    nubes = "nubes-casapora.png";
  break;
  case "conexo.html":
    nubes = "nubes-conexo.png";
  break;
  case "educacion-aborigen.html":
    nubes = "nubes-educacion.png";
  break;
  case "la-polinizadora.html":
    nubes = "nubes-polinizadora.png";
  break;
  case "ninas-anomalas.html":
    nubes = "nubes-ninas.png";
  break;
  case "popayork-minga.html":
    nubes = "nubes-popayork.png";
  break;
  case "rhesident-org.html":
    nubes = "nubes-rhesident.png";
  break;
  case "volcan.html":
    nubes = "nubes-volcan.png";
  break;
};

var style = document.createElement('style');
style.innerHTML = `
#secDescripcion:before{
    position: absolute;
    background: url('./images/colectivos/nubes/`+ nubes+`');
    background-repeat: no-repeat;
    background-size: contain;
    /*top: -25%;*/
    top: calc(0% - `+ sum +`);
    left: 0;
    width: 100%;
    height: 100%;
    content: "";
    color: transparent;
  }
`;
document.head.appendChild(style);

function scrollAnima(){
  btonPlayAnim.scrollIntoView();
}

function scrollaMapa(){
  contenedorMapa.scrollIntoView();
}

function abrirModalPrincipal(){
  let modalPrincipal = new bootstrap.Modal(document.getElementById('bienal2022'), {});
  modalPrincipal.show(); 
}

function relacionesColectivasMenu(){
let relacionColectiva1 = document.getElementById("relacioncolectiva1");
let relacionColectiva2 = document.getElementById("relacioncolectiva2");
let relacionColectiva3 = document.getElementById("relacioncolectiva3");

relacionColectiva1.addEventListener("click", relacionesColectivas1);
relacionColectiva2.addEventListener("click", relacionesColectivas2);
relacionColectiva3.addEventListener("click", relacionesColectivas3);

let soberania; 
let practicas; 
let cuerpocomo;

function relacionesColectivas1(){
  soberania = document.querySelector("g#soberania");
  practicas = document.querySelector("g#practicas");
  cuerpocomo = document.querySelector("g#cuerpocomo");
  let caminos = document.querySelectorAll(".st55");
  for (var i = 0; i < caminos.length; ++i) {
    caminos[i].style.display = "none";
  }
  soberania.classList.remove("ocultarcamino");
  soberania.classList.add("mostrarcamino");
  practicas.classList.remove("mostrarcamino");
  practicas.classList.add("ocultarcamino");
  cuerpocomo.classList.remove("mostrarcamino");
  cuerpocomo.classList.add("ocultarcamino");
 
}

function relacionesColectivas2(){
  soberania = document.querySelector("g#soberania");
  practicas = document.querySelector("g#practicas");
  cuerpocomo = document.querySelector("g#cuerpocomo");
  let caminos = document.querySelectorAll(".st55");
  for (var i = 0; i < caminos.length; ++i) {
    caminos[i].style.display = "none";
  }
  soberania.classList.remove("mostrarcamino");
  soberania.classList.add("ocultarcamino");
  practicas.classList.remove("mostrarcamino");
  practicas.classList.add("ocultarcamino");
  cuerpocomo.classList.remove("ocultarcamino");
  cuerpocomo.classList.add("mostrarcamino");
}

function relacionesColectivas3(){
  soberania = document.querySelector("g#soberania");
  practicas = document.querySelector("g#practicas");
  cuerpocomo = document.querySelector("g#cuerpocomo");
  let caminos = document.querySelectorAll(".st55");
  for (var i = 0; i < caminos.length; ++i) {
    caminos[i].style.display = "none";
  }
  soberania.classList.remove("mostrarcamino");
  soberania.classList.add("ocultarcamino");
  practicas.classList.remove("ocultarcamino");
  practicas.classList.add("mostrarcamino");
  cuerpocomo.classList.remove("mostrarcamino");
  cuerpocomo.classList.add("ocultarcamino");
}

}
